import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { __, __r } from 'react-i18n/lib';
import { Button } from '../General/Button';
import { Input } from '../General/Input';

export const secondaryText = css`
  color: ${({ theme }) => theme.colors.textPrimary};
  text-decoration-color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.font.secondary};
  font-weight: 400;
  font-size: ${rem(14)};
  line-height: ${rem(22)};
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: ${rem(352)};
  background: ${({ theme }) => theme.colors.white};
`;

export const Header = styled.h1`
  font-size: ${rem(30)};
  font-weight: 400;
  position: relative;
  font-family: ${({ theme }) => theme.font.primary};
  margin-bottom: ${rem(32)};
  line-height: ${rem(38)};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const Form = styled.form`
  margin: 0;
  & input:first-of-type {
    margin-bottom: ${rem(16)};
  }
`;

export const Required = styled.span`
  font-size: ${rem(12)};
  font-family: ${({ theme }) => theme.font.tertiary};
  line-height: ${rem(20)};
  color: ${({ theme }) => theme.colors.stockCountUnavailable};
`;

export const LoginButton = styled(Button)`
  height: ${rem(48)};
  padding: ${rem(8)};
  width: 100%;
  max-width: ${rem(352)};
  background-color: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.black};
  font-size: ${rem(14)};
  border-radius: ${rem(2)};
  margin: ${rem(24)} 0;

  &:disabled {
    background-color: #dcd6d6;
  }
`;

export const Register = styled.p`
  ${secondaryText};
  display: inline-block;
  text-decoration: underline;
  margin: 0;
  margin-left: ${rem(4)};
`;

export const NoAccountWrapper = styled.span`
  ${secondaryText};
  display: flex;
  justify-content: center;
`;

export const FormInput = styled(Input)`
  font-size: ${rem(14)};
`;
